import MatterComp from './matterComp.jsx'
import { useEffect, useCallback} from 'react'
import { RotateLeft, RotateRight } from '@material-ui/icons';
import useSound from 'use-sound';

import laser1Sfx from './../sounds/laser1.mp3';
import laser2Sfx from './../sounds/laser2.mp3';
import laser3Sfx from './../sounds/laser3.mp3';
import hitSfx from './../sounds/hit.mp3';
import phitSfx from './../sounds/phit.mp3';

import boltorange from './../sprites/boltorange-250-min.png'
import boltred from './../sprites/boltred-250-min.png'
import boltyellow from './../sprites/boltyellow-250-min.png'

function GameScreen (props) {


  const {shotCount, setShotCount, scores,setScores, soundOn, bugLevels, setBugLevels, timer, setRotating,rotating,setFired,fired,score,setScore} = props
  
  const [laser1] = useSound(laser1Sfx);
  const [laser2] = useSound(laser2Sfx);
  const [laser3] = useSound(laser3Sfx);
  const [hit] = useSound(hitSfx);
  const [phit] = useSound(phitSfx);

  
  const changeScore = (change) => {
    setScore(score => score + change)
  }
  const rotate = useCallback((direction) => {
    setRotating(direction)
  }, [setRotating]);
  

  const stopRotate = useCallback(() => {
    setRotating(false)
  },[setRotating]);

  const fireYellow = (e) => {
    e.preventDefault()
    if (!fired) {
    setFired("yellow")
    if (soundOn)  laser1()
    }
  }

  const fireOrange = (e) => {
    e.preventDefault()
    if (!fired) {
    setFired("orange")
    if (soundOn)  laser3()
    }
  }

  const fireRed = (e) => {
    e.preventDefault()
    if (!fired) {
    setFired("red")
    if (soundOn) laser2()
    }
  }
  

  useEffect(() => {

    const handleUserKeyPress = (e) => {
      switch (e.key.toLowerCase()) {
        case 'a':
          rotate(-1)
          break;
        case 'd':
          rotate(1)
          break;
        case 'j':
          if (soundOn) laser1()
          setFired("yellow")
          break;
        case 'k':
          if (soundOn) laser2()
          setFired("orange")
          break;
        case 'l':
          if (soundOn) laser3()
          setFired("red")
          break;
        default: // Do nothing
      }
    }


  
    const handleUserKeyUp = (e) => {
      switch (e.key.toLowerCase()) {
        case 'a':
          stopRotate()
          break;
        case 'd':
          stopRotate()
          break;
        default: // Do nothing
      }
    }
    window.addEventListener('keydown', handleUserKeyPress);
    window.addEventListener('keyup', handleUserKeyUp);

    if (fired) setFired(false)
  
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress)
      window.addEventListener('keyup', handleUserKeyUp);

    }
  },[fired,setFired, rotate, stopRotate, laser1, laser2, laser3, soundOn])

  return (
    <>
          <h1>BATTLING THE BUGS</h1>

      <div id="scorebar">
        <div id="timer">
        {Math.round(timer)}
        </div>
        <div id="score"><p>{score}</p></div>

        </div>
      <MatterComp shotCount={shotCount} setShotCount={setShotCount}  timer={Math.round(timer)} scores={scores} setScores={setScores} soundOn={soundOn} bugLevels={bugLevels} setBugLevels={setBugLevels} hit={hit} phit={phit} changeScore={changeScore} fired={fired} rotating={rotating} />
      <div id="buttons">
        <div id="rbuttons">
          <div className="gbutton">
          <button  
          onTouchCancel={stopRotate} onTouchEnd={stopRotate} onTouchStart={() => rotate(-1)}
          onMouseDown={() => rotate(-1)} onMouseUp={stopRotate} onMouseLeave={stopRotate}  id="rotateL"><RotateLeft />
                    <div className="innerBorder"> </div>

          </button>
          
          <div className="letter">A</div>
          </div>
          <div className="gbutton">

          <button  
          onTouchCancel={stopRotate} onTouchEnd={stopRotate} onTouchStart={() => rotate(1)}
          onMouseDown={() => rotate(1)} onMouseUp={stopRotate} onMouseLeave={stopRotate} className="rotate"  id="rotateR"><RotateRight />
                              <div className="innerBorder"> </div>

          </button>
          <div className="letter">D</div>

          </div>

        </div>
        <div id="fbuttons">
        <div className="gbutton">

        <button 
        onMouseUp={fireYellow}
        onTouchEnd={fireYellow}
        style={{
          backgroundImage: `url(${boltyellow})`,

        }}
        
        id="yellow" className="fire">

<div className="innerBorder" id="yellowBorder"

style={{
  borderWidth: shotCount.yellow < 19 ? 10 - (shotCount.yellow/2) : 1
}}
></div><div className="evenInnerBorder"


></div>
        </button>
        <div className="letter">J</div>

        </div>

        <div className="gbutton">

<button 
style={{
  backgroundImage: `url(${boltorange})`,
  transform: "rotate(180deg)"
}}
onMouseUp={fireOrange}
onTouchEnd={fireOrange}
id="orange" className="fire">
  <div className="innerBorder" id="orangeBorder" style={{
borderWidth: shotCount.orange < 19 ? 10 - (shotCount.orange/2) : 1
}}
></div><div className="evenInnerBorder"


></div>


</button>
<div className="letter">L</div>

</div>
        <div className="gbutton">

        <button  
        style={{
          backgroundImage: `url(${boltred})`
        }}
        onMouseUp={fireRed}
        onTouchEnd={fireRed}
        id="red" className="fire">

<div className="innerBorder" id="redBorder" 
style={{
  borderWidth: shotCount.red < 19 ? 10 - (shotCount.red/2) : 1
}}
></div><div className="evenInnerBorder"


></div>

        </button>
        <div className="letter">K</div>

        </div>

     

        </div>
      </div>
    
    </>
  )
}

export default GameScreen